import React, { PureComponent } from 'react';
import { PrimaryButton, Icon } from 'appSrc/components/UI';
import { DL_COLORS } from 'appSrc/utils';
import style from './styles/style.module.css';


class EditWrapper extends PureComponent {
    constructor( props ) {
        super( props );

        this.state = {
            setting: 'view',
        };
    }
    toggle = ( newSetting ) => {
        return () => {
            this.setState( { setting: newSetting } );
        };
    }
    onSave = () => {
        this.props.onSave();
        this.setState( { setting: 'view' } );
    }


    render() {
        const { canEdit } = this.props;
        const className = `${ style.editWrapper } ${ this.props.className }`.trim();

        const { setting } = this.state;

        if( setting == 'view' ) {
            var viewChild = React.cloneElement( this.props.viewChild, {
                className: ( ( this.props.viewChild.props.className || '' ) + ' content view-content' ).trim(),
            } );

            return (
                <div className={ className }>
                    { viewChild }
                    { canEdit &&
                        <Icon className={ style.editIcon } onClick={ this.toggle( 'edit' ) }
                        source='fontAwesome' icon='fas/faEdit' style={ { color: DL_COLORS.primary } } />
                    }
                </div>
            );
        }
        if( setting == 'edit' ) {
            var editChild = React.cloneElement( this.props.editChild, {
                className: ( ( this.props.editChild.props.className || '' ) + ' content edit-content' ).trim(),
            } );

            return (
                <div className={ className }>
                    { editChild }
                    <div className={ style.buttonSet }>
                        <PrimaryButton label='Save' onClick={ this.onSave } />
                        <PrimaryButton label='Cancel' reverse
                        onClick={ this.toggle( 'view' ) } />
                    </div>
                </div>
            );
        }
    }
}
EditWrapper.defaultProps = {
    canEdit: false,
    className: '',
    viewChild: null,
    editChild: null,
    onSave: () => {},
};

export default EditWrapper;
